import { commonRoutes } from './commonRoutes';

export const stakeholderOperationRoutes = {
  STAKEHOLDER_OPERATION: '/sop',
  get LOGIN() {
    return `${this.STAKEHOLDER_OPERATION}/${commonRoutes.LOGIN}`;
  },
  get FORGOT_PASSWORD() {
    return `${this.STAKEHOLDER_OPERATION}/${commonRoutes.FORGOT_PASSWORD}`;
  },
  get CREATE_PASSWORD() {
    return `${this.STAKEHOLDER_OPERATION}/${commonRoutes.CREATE_PASSWORD}`;
  },
  get RESET_PASSWORD() {
    return `${this.STAKEHOLDER_OPERATION}/${commonRoutes.RESET_PASSWORD}`;
  },
  get DASHBOARD() {
    return `${this.STAKEHOLDER_OPERATION}/${commonRoutes.DASHBOARD}`;
  },
  get PROFILE() {
    return `${this.STAKEHOLDER_OPERATION}/${commonRoutes.PROFILE}`;
  },
  get UNITS() {
    return `${this.STAKEHOLDER_OPERATION}/units`;
  },
  get OPERATIONS() {
    return `${this.STAKEHOLDER_OPERATION}/operations`;
  },
  get DEMAND_OPERATIONS() {
    return `${this.STAKEHOLDER_OPERATION}/demand_operations`;
  },
  get MEDICAL_ESTABLISHMENT_DRUG_SHORTAGE() {
    return `${this.STAKEHOLDER_OPERATION}/medical-establishment-drug-shortage`;
  },
  get My_Packages() {
    return `${this.STAKEHOLDER_OPERATION}/my_packages`;
  },
  get DRUGS() {
    return `${this.STAKEHOLDER_OPERATION}/drugs`;
  },
  get UNIT_INQUIRY() {
    return `${this.UNITS}/unit-inquiry`;
  },
  get INCOMMING_UNPROCESSED_UNITS() {
    return `${this.UNITS}/incomming-unprocessed-units`;
  },
  get SUPPLY_NOTIFICATION_INQUIRY() {
    return `${this.UNITS}/supply-notification-inquiry`;
  },
  get PRESCRIPTION_INQUIRY() {
    return `${this.UNITS}/prescription-inquiry`;
  },
  get MY_USERS() {
    return `${this.STAKEHOLDER_OPERATION}/my-users`;
  },
  get NEW_USER() {
    return `${this.MY_USERS}/new-user`;
  },
  get EDIT_USER() {
    return `${this.MY_USERS}/edit-user`;
  },
  get STAKEHOLDERS() {
    return `${this.STAKEHOLDER_OPERATION}/stakeholders`;
  },
  get MY_DRUGS() {
    return `${this.DRUGS}/my-drugs`;
  },
  get SHORTAGE_REPORT() {
    return `${this.DRUGS}/shortage-report`;
  },
  get SHORTAGE_REPORT_UPDATE() {
    return `${this.SHORTAGE_REPORT}/update-request`;
  },
  get SHORTAGE_REPORT_NEW_REQUEST() {
    return `${this.SHORTAGE_REPORT}/new-request`;
  },
  get DISPATCHED_PACKAGES() {
    return `${this.My_Packages}/dispatched-packages`;
  },
  get DISPATCHED_PACKAGES_DETAILS() {
    return `${this.STAKEHOLDER_OPERATION}/dispatched-packages-details`;
  },
  get EVALUATE_DISPATCHED_PACKAGES() {
    return `${this.STAKEHOLDER_OPERATION}/evaluate-dispatched-packages`;
  },
  get PACKAGE_DETAILS() {
    return `${this.STAKEHOLDER_OPERATION}/package-details`;
  },
  get ACCEPT_PACKAGES() {
    return `${this.My_Packages}/accept-packages`;
  },
  get ACCEPT_PACKAGES_DETAILS() {
    return `${this.STAKEHOLDER_OPERATION}/accept-packages-details`;
  },
  get EVALUATE_ACCEPT_PACKAGES() {
    return `${this.STAKEHOLDER_OPERATION}/evaluate-accept-packages`;
  },
  get ACCEPT_PACKAGES_COMMENT() {
    return `${this.STAKEHOLDER_OPERATION}/accept-packages-comment`;
  },
  get IMPORT() {
    return `${this.OPERATIONS}/import`;
  },
  get CANCEL_IMPORT() {
    return `${this.STAKEHOLDER_OPERATION}/cancel-import`;
  },
  get DISPATCH() {
    return `${this.OPERATIONS}/dispatch`;
  },
  get DISPATCH_BY_BN() {
    return `${this.OPERATIONS}/dispatch-by-bn`;
  },
  get DISPATCH_CANCEL() {
    return `${this.OPERATIONS}/cancel-dispatch`;
  },
  get DISPATCH_CANCEL_BY_BN() {
    return `${this.OPERATIONS}/cancel-dispatch-by-bn`;
  },
  get ACCEPT() {
    return `${this.OPERATIONS}/accept`;
  },
  get ACCEPT_BY_BN() {
    return `${this.OPERATIONS}/accept-by-bn`;
  },
  get RETURN() {
    return `${this.OPERATIONS}/return`;
  },
  get RETURN_BY_BN() {
    return `${this.OPERATIONS}/return-by-bn`;
  },
  get EXPORT_UNIT() {
    return `${this.OPERATIONS}/export-unit`;
  },
  get EXPORT_CANCEL() {
    return `${this.OPERATIONS}/export-cancel`;
  },
  get DEACTIVATE_UNIT() {
    return `${this.OPERATIONS}/deactivate-unit`;
  },
  get CANCEL_DEACTIVATE() {
    return `${this.OPERATIONS}/cancel-deactivate`;
  },
  get ANNOUNCEMENTS_NEWS() {
    return `${this.STAKEHOLDER_OPERATION}/announcements-and-news`;
  },
  get VIEW_ANNOUNCEMENT() {
    return `${this.STAKEHOLDER_OPERATION}/view-announcement`;
  },
  get HELP_DESK() {
    return `${this.STAKEHOLDER_OPERATION}/help-desk`;
  },
  get CREATE_TICKET() {
    return `${this.STAKEHOLDER_OPERATION}/create-ticket`;
  },
  get VIEW_TICKET() {
    return `${this.STAKEHOLDER_OPERATION}/view-ticket`;
  },
  get OFFER_LIST() {
    return `${this.DEMAND_OPERATIONS}/offer-list`;
  },
  get SUBMIT_DEMAND_TO_OFFER() {
    return `${this.STAKEHOLDER_OPERATION}/offer-demand-list`;
  },
  get DEMANDS_TO_MY_OFFER() {
    return `${this.STAKEHOLDER_OPERATION}/offer-my-demands`;
  },
  get DEMANDS_OFFER_CHAT() {
    return `${this.STAKEHOLDER_OPERATION}/offer-demands-chat`;
  },
  get OFFERS_TO_MY_DEMAND() {
    return `${this.STAKEHOLDER_OPERATION}/offers-to-my-demand`;
  },
  get DEMAND_LIST() {
    return `${this.DEMAND_OPERATIONS}/demand-list`;
  },
  get MEDICAL_ESTABLISHMENT_DRUG_SHORTAGE_LIST() {
    return `${this.MEDICAL_ESTABLISHMENT_DRUG_SHORTAGE}/shortage-list`;
  },
  get MEDICAL_ESTABLISHMENT_DRUG_SHORTAGE_CREATE() {
    return `${this.MEDICAL_ESTABLISHMENT_DRUG_SHORTAGE}/shortage-create`;
  },

  get EDIT_DEMAND_LIST() {
    return `${this.STAKEHOLDER_OPERATION}/edit-demand-list`;
  },
  get CREATE_DEMAND() {
    return `${this.DEMAND_LIST}/create`;
  },
  get SUBMIT_OFFER_TO_DEMAND() {
    return `${this.STAKEHOLDER_OPERATION}/demand-offer-list`;
  },
  get REPORT() {
    return `${this.STAKEHOLDER_OPERATION}/reporting`;
  },
  get DRUG_COUNT() {
    return `${this.REPORT}/drug-count`;
  },
  get UNIT_LIST() {
    return `${this.REPORT}/unit-list`;
  },
  get EXPIRED_DRUG_LIST() {
    return `${this.REPORT}/expired-drug-list`;
  },
  get OPERATION_LIST() {
    return `${this.REPORT}/operation-list`;
  },
  get OPERATION_DETAIL_LIST() {
    return `${this.OPERATION_LIST}/:id`;
  },
  get INTEGRATION_DOC() {
    return `${this.STAKEHOLDER_OPERATION}/integration-doc`;
  },
  get SUPPLY() {
    return `${this.OPERATIONS}/operations-supply`;
  },
  get SUPPLY_CANCEL() {
    return `${this.OPERATIONS}/supply-cancel`;
  },
  get IMPORT_CANCEL() {
    return `${this.OPERATIONS}/import-cancel`;
  },
  get DRUG_SALE() {
    return `${this.OPERATIONS}/operations-drug-sale`;
  },
  get DRUG_SALE_CANCEL() {
    return `${this.OPERATIONS}/drug-sale-cancel`;
  },
  get CONSUME() {
    return `${this.OPERATIONS}/operations-consume`;
  },
  get CONSUME_CANCEL() {
    return `${this.OPERATIONS}/consume-cancel`;
  },
  get TRANSFER() {
    return `${this.OPERATIONS}/operations-transfer`;
  },
  get TRANSFER_BY_BN() {
    return `${this.OPERATIONS}/transfer-by-bn`;
  },
  get TRANSFER_CANCEL() {
    return `${this.OPERATIONS}/transfer-cancel`;
  },
  get TRANSFER_CANCEL_BY_BN() {
    return `${this.OPERATIONS}/transfer-cancel-by-bn`;
  },
  get DEACTIVATE_CANCEL() {
    return `${this.OPERATIONS}/deeactivate-cancel`;
  },
  get REDISTRIBUTION_OPERATIONS() {
    return `${this.STAKEHOLDER_OPERATION}/redistribution`;
  },
  get REDISTRIBUTION_DEMAND_LIST() {
    return `${this.REDISTRIBUTION_OPERATIONS}/demand-list`;
  },
  get REDISTRIBUTION_DEMAND_DETAILS() {
    return `${this.REDISTRIBUTION_OPERATIONS}/demand-details`;
  },
  get REDISTRIBUTION_DEMAND_CREATE() {
    return `${this.REDISTRIBUTION_OPERATIONS}/demand-create`;
  },
  get REDISTRIBUTION_DEMAND_EDIT() {
    return `${this.REDISTRIBUTION_OPERATIONS}/demand-edit`;
  },
  get STOCK_MATCH() {
    return `${this.STAKEHOLDER_OPERATION}/stock-match`;
  },
  get SOP_STOCK_MATCH_LOG_LIST() {
    return `${this.STAKEHOLDER_OPERATION}/stock-match-log-list`;
  },
  get SOP_STOCK_MATCH_LOG_DETAILS() {
    return `${this.SOP_STOCK_MATCH_LOG_LIST}/:id`;
  },
  get CHATBOT() {
    return `${this.STAKEHOLDER_OPERATION}/chatbot`;
  }
};

export const stakeholderOperationbreadcrumbTitlesKey = {
  [stakeholderOperationRoutes.STAKEHOLDER_OPERATION]: 'pageTitles.stakeholderOperationPortal',
  [stakeholderOperationRoutes.LOGIN]: 'pageTitles.title',
  [stakeholderOperationRoutes.DASHBOARD]: 'pageTitles.dashboard',
  [stakeholderOperationRoutes.UNITS]: 'pageTitles.units',
  [stakeholderOperationRoutes.DRUGS]: 'pageTitles.drugs',
  [stakeholderOperationRoutes.OPERATIONS]: 'pageTitles.operations',
  [stakeholderOperationRoutes.My_Packages]: 'pageTitles.myPackages',
  [stakeholderOperationRoutes.DEMAND_OPERATIONS]: 'pageTitles.offerDemandOperations',
  [stakeholderOperationRoutes.INCOMMING_UNPROCESSED_UNITS]: 'pageTitles.incomingUnits',
  [stakeholderOperationRoutes.SUPPLY_NOTIFICATION_INQUIRY]: 'pageTitles.supplyNotifications',
  [stakeholderOperationRoutes.REPORT]: 'pageTitles.reports',
  [stakeholderOperationRoutes.DRUG_COUNT]: 'pageTitles.drugCount',
  [stakeholderOperationRoutes.UNIT_LIST]: 'pageTitles.unitList',
  [stakeholderOperationRoutes.EXPIRED_DRUG_LIST]: 'pageTitles.expiredDrugList',
  [stakeholderOperationRoutes.OPERATION_LIST]: 'pageTitles.operationList',
  [stakeholderOperationRoutes.SHORTAGE_REPORT]: 'pageTitles.shortageReport',
  [stakeholderOperationRoutes.SHORTAGE_REPORT_UPDATE]: 'pageTitles.shortageReportUpdate',
  [stakeholderOperationRoutes.PACKAGE_DETAILS]: 'pageTitles.packageDetails',
  [stakeholderOperationRoutes.PRESCRIPTION_INQUIRY]: 'pageTitles.prescriptionInquiry',
  [stakeholderOperationRoutes.MY_USERS]: 'sideMenu.myUsers',
  [stakeholderOperationRoutes.NEW_USER]: 'pageTitles.newUser',
  [stakeholderOperationRoutes.EDIT_USER]: 'pageTitles.editUser',
  [stakeholderOperationRoutes.HELP_DESK]: 'pageTitles.helpDesk',
  [stakeholderOperationRoutes.CREATE_TICKET]: 'pageTitles.createTicket',
  [stakeholderOperationRoutes.VIEW_TICKET]: 'pageTitles.helpDesk',
  [stakeholderOperationRoutes.INTEGRATION_DOC]: 'pageTitles.integrationDocuments',
  [stakeholderOperationRoutes.FORGOT_PASSWORD]: 'pageTitles.forgotPassword',
  [stakeholderOperationRoutes.PROFILE]: 'pageTitles.profile',
  [stakeholderOperationRoutes.UNIT_INQUIRY]: 'pageTitles.unitInquery',
  [stakeholderOperationRoutes.STAKEHOLDERS]: 'pageTitles.stakeholders',
  [stakeholderOperationRoutes.MY_DRUGS]: 'pageTitles.myDrugs',
  [stakeholderOperationRoutes.SHORTAGE_REPORT_NEW_REQUEST]: 'pageTitles.shortageReport',
  [stakeholderOperationRoutes.DISPATCHED_PACKAGES]: 'pageTitles.dispatchedPackages',
  [stakeholderOperationRoutes.DISPATCHED_PACKAGES_DETAILS]: 'pageTitles.dispatchedPackages',
  [stakeholderOperationRoutes.EVALUATE_DISPATCHED_PACKAGES]: 'pageTitles.dispatchedPackages',
  [stakeholderOperationRoutes.ACCEPT_PACKAGES]: 'pageTitles.acceptPackages',
  [stakeholderOperationRoutes.ACCEPT_PACKAGES_DETAILS]: 'pageTitles.acceptPackages',
  [stakeholderOperationRoutes.EVALUATE_ACCEPT_PACKAGES]: 'pageTitles.acceptPackages',
  [stakeholderOperationRoutes.ACCEPT_PACKAGES_COMMENT]: 'pageTitles.acceptPackages',
  [stakeholderOperationRoutes.IMPORT]: 'pageTitles.import',
  [stakeholderOperationRoutes.CANCEL_IMPORT]: 'pageTitles.importCancel',
  [stakeholderOperationRoutes.DISPATCH]: 'pageTitles.dispatch',
  [stakeholderOperationRoutes.DISPATCH_BY_BN]: 'pageTitles.dispatchByBN',
  [stakeholderOperationRoutes.DISPATCH_CANCEL]: 'pageTitles.dispatchCancel',
  [stakeholderOperationRoutes.DISPATCH_CANCEL_BY_BN]: 'pageTitles.dispatchCancelByBN',
  [stakeholderOperationRoutes.ACCEPT]: 'pageTitles.accept',
  [stakeholderOperationRoutes.ACCEPT_BY_BN]: 'pageTitles.acceptByBN',
  [stakeholderOperationRoutes.RETURN]: 'pageTitles.return',
  [stakeholderOperationRoutes.RETURN_BY_BN]: 'pageTitles.returnByBN',
  [stakeholderOperationRoutes.EXPORT_UNIT]: 'pageTitles.exportUnit',
  [stakeholderOperationRoutes.EXPORT_CANCEL]: 'pageTitles.exportCancel',
  [stakeholderOperationRoutes.DEACTIVATE_UNIT]: 'pageTitles.deactivateUnit',
  [stakeholderOperationRoutes.CANCEL_DEACTIVATE]: 'pageTitles.deactivationCancel',
  [stakeholderOperationRoutes.ANNOUNCEMENTS_NEWS]: 'pageTitles.announcement&news',
  [stakeholderOperationRoutes.VIEW_ANNOUNCEMENT]: 'pageTitles.announcement&news',
  [stakeholderOperationRoutes.OFFER_LIST]: 'pageTitles.offerList',
  [stakeholderOperationRoutes.SUBMIT_DEMAND_TO_OFFER]: 'pageTitles.offerList',
  [stakeholderOperationRoutes.DEMAND_LIST]: 'pageTitles.demandList',
  [stakeholderOperationRoutes.EDIT_DEMAND_LIST]: 'pageTitles.demandList',
  [stakeholderOperationRoutes.CREATE_DEMAND]: 'pageTitles.addNewDemand',
  [stakeholderOperationRoutes.SUBMIT_OFFER_TO_DEMAND]: 'pageTitles.demandList',
  [stakeholderOperationRoutes.OFFERS_TO_MY_DEMAND]: 'pageTitles.demandList',
  [stakeholderOperationRoutes.DEMANDS_OFFER_CHAT]: 'pageTitles.RSDChat',
  [stakeholderOperationRoutes.OPERATION_DETAIL_LIST]: 'pageTitles.operationDetailList',
  [stakeholderOperationRoutes.SUPPLY]: 'pageTitles.supply',
  [stakeholderOperationRoutes.SUPPLY_CANCEL]: 'pageTitles.supplyCancel',
  [stakeholderOperationRoutes.IMPORT_CANCEL]: 'pageTitles.importCancel',
  [stakeholderOperationRoutes.DRUG_SALE]: 'pageTitles.drugSale',
  [stakeholderOperationRoutes.DRUG_SALE_CANCEL]: 'pageTitles.drugSaleCancel',
  [stakeholderOperationRoutes.CONSUME]: 'pageTitles.consume',
  [stakeholderOperationRoutes.CONSUME_CANCEL]: 'pageTitles.consumeCancel',
  [stakeholderOperationRoutes.TRANSFER]: 'pageTitles.transfer',
  [stakeholderOperationRoutes.TRANSFER_BY_BN]: 'pageTitles.transferByBatchNumber',
  [stakeholderOperationRoutes.TRANSFER_CANCEL]: 'pageTitles.transferCancel',
  [stakeholderOperationRoutes.TRANSFER_CANCEL_BY_BN]: 'pageTitles.transferCancelByBN',
  [stakeholderOperationRoutes.DEACTIVATE_CANCEL]: 'pageTitles.deactivationCancel',
  [stakeholderOperationRoutes.MEDICAL_ESTABLISHMENT_DRUG_SHORTAGE_LIST]:
    'pageTitles.drugShortage',
  [stakeholderOperationRoutes.MEDICAL_ESTABLISHMENT_DRUG_SHORTAGE_CREATE]:
    'pageTitles.medicalEstablishmentDrugShortageCreate',
  [stakeholderOperationRoutes.MEDICAL_ESTABLISHMENT_DRUG_SHORTAGE]: 'pageTitles.medicalEstablishmentDrugShortage',
  [stakeholderOperationRoutes.REDISTRIBUTION_OPERATIONS]: 'pageTitles.redistributionOperations',
  [stakeholderOperationRoutes.REDISTRIBUTION_DEMAND_LIST]: 'pageTitles.redistributionDemandList',
  [stakeholderOperationRoutes.REDISTRIBUTION_DEMAND_DETAILS]: 'pageTitles.redistributionDemandDetails',
  [stakeholderOperationRoutes.REDISTRIBUTION_DEMAND_CREATE]: 'pageTitles.redistributionDemandCreate',
  [stakeholderOperationRoutes.REDISTRIBUTION_DEMAND_EDIT]: 'pageTitles.redistributionDemandEdit',
  [stakeholderOperationRoutes.STOCK_MATCH]: 'pageTitles.stockMatch',
  [stakeholderOperationRoutes.SOP_STOCK_MATCH_LOG_LIST]: 'pageTitles.stockMatchLogList',
  [stakeholderOperationRoutes.SOP_STOCK_MATCH_LOG_DETAILS]: 'pageTitles.stockMatchLogDetails',
  [stakeholderOperationRoutes.CHATBOT]: 'pageTitles.chatbot'
};
